import {BaseModel} from '@/core/standard/BaseModel';
import {
  DomicilePickupSettingsProtocol,
  IDomicilePickups,
  IDomicilePickupSettingsModel,
} from '@/modules/settings/domicile_pickup/IDomicilePickupSettingsModel';
import DomicilePickupSettingServices from '@/modules/settings/domicile_pickup/DomicilePickupSettingServices';
import DomicilePickupBarsHoursSettingServices from '@/modules/settings/domicile_pickup/DomicilePickupBarsHoursSettingServices';

const domicilePickup = {
  block_domicile_order: false,
  block_pickup_order: false,
  price_domicile_service: 0,
  minimal_amount_domicile: 0,
  auto_accept_domicile: false,
  auto_accept_pickup: false,
  orders_time: [],
  allow_order_time_delay: false,
  shift_duration: 0,
  minimal_anticipation_pickup: 0,
  minimal_anticipation_domicile: 0,
  max_products_by_turn: 0,
  categories: [],
  domicile_orders_limit: 1,
  maximum_radius_domicile: 0,
  request_without_client_domicile: false,
  request_without_client_pickup: false,
};

// tslint:disable-next-line:max-line-length
class DomicilePickupSettingsModel extends BaseModel<IDomicilePickupSettingsModel, DomicilePickupSettingsProtocol, typeof DomicilePickupSettingServices> {
  public modelName = 'DomicilePickup';
  public request = 'JSON';

  constructor() {
    super(domicilePickup, DomicilePickupSettingServices);
  }

  public async create(data: FormData, toast: any, toastConfig: any) {
    const request = await this.service.request({method: 'PUT', query: data});
    if (request.complete) {
      return this.handleSuccess(request.data, request.message, toast);
    } else {
      this.handleError(request, toast);
      return false;
    }
  }

  public async getWorkHours(toast) {
    const request = await DomicilePickupBarsHoursSettingServices.getAll({});
    if (request.complete) {
      return this.handleSuccess({
        data: request.data.results,
        total: request.data.total,
      }, request.message, null);
    } else {
      this.handleError(request, toast);
      return {data: [], total: 0};
    }
  }

  public async getShiftsTimes(dataShifts, toast) {
    const response = await DomicilePickupBarsHoursSettingServices.getShiftsTimes({
      method: 'GET',
      query: dataShifts,
    });
    if (response.complete) {
      return response
    } else {
      let showToast = (dataShifts.type !== 'local') ? toast : undefined
      this.handleError(response, showToast);
      return {data: [], total: 0};
    }
  }

  public async insertWorkHour(data, toast) {
    const response = await DomicilePickupBarsHoursSettingServices.insert({query: {...data}});
    if (response.complete) {
      return this.handleSuccess(response.data, response.message, null);
    }
    this.handleError(response, toast);
    return false;
  }

  public async deleteWorkHour(data, toast) {
    const {id} = data;
    delete data.id;
    const response = await DomicilePickupBarsHoursSettingServices.deleteBy({id});
    if (response.complete) {
      return this.handleSuccess(response.data, response.message, null);
    }
    this.handleError(response, toast);
    return false;
  }

  public async updateWorkHour(data, toast) {
    const {id} = data;
    delete data.id;
    const response = await DomicilePickupBarsHoursSettingServices.update({
      id,
      query: {...data},
    });
    if (response.complete) {
      return this.handleSuccess(response.data, response.message, null);
    }
    this.handleError(response, toast);
    return false;
  }


  public async changeDayStatus({day, status}, toast) {
    const response = await DomicilePickupBarsHoursSettingServices.update({
      url: 'change_status',
      query: {day, status},
    });
    if (response.complete) {
      return this.handleSuccess(response.data, response.message, null);
    }
    this.handleError(response, toast);
    return false;
  }

}

export default DomicilePickupSettingsModel as new() => IDomicilePickups;
